// extracted by mini-css-extract-plugin
module.exports = {"brandTrendingWrap":"ve"};